import { render, staticRenderFns } from "./detailsBanner.vue?vue&type=template&id=9bac1950&"
import script from "./detailsBanner.vue?vue&type=script&lang=js&"
export * from "./detailsBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports